import request from '@/utils/request'

// 获取首页轮播图
export function getBenner() {
  return request({
    url: '/exhibition/dic/type/exhibition_hall_index_img',
    method: 'get',
  })
}

// 获取首页栏目
export function getColumn() {
  return request({
    url: '/exhibition/column',
    method: 'get',
  })
}

// 获取筛选条件
export function getScreening(data) {
  return request({
    url: `/exhibition/category/repertory`,
    method: 'post',
    data,
  })
}
export function getKeyword(data) {
  return request({
    url: `/exhibition/dic/type/element_keyword`,
    method: 'get',
    data,
  })
}
export function getKz(data) {
  return request({
    url: `/exhibition/dic/type/exhibition_hall_kz`,
    method: 'get',
    data,
  })
}
export function getSeries(data) {
  return request({
    url: `/exhibition/dic/type/standard_series`,
    method: 'get',
    data,
  })
}

// 列表
export function getGoodsList(data) {
  return request({
    url: `/exhibition/product?current=${data.current}&size=${data.size}`,
    method: 'post',
    data,
  })
}

// 获取普通款筛选条件
export function getFilterCond() {
  return request({
    url: '/exhibition/cloudhall/goods/criteria',
    method: 'get',
    params: {},
  })
}

// 获取素金筛选条件
export function getPlainCond() {
  return request({
    url: '/exhibition/cloudhall/goods/goldCriteria',
    method: 'get',
    params: {},
  })
}
// 输入框商品
export function getKeyWord(data) {
  return request({
    url:
      '/exhibition/cloudhall/goods/search?pageSize=' +
      data.pageSize +
      '&pageNum=' +
      data.pageNum,
    method: 'post',
    data,
  })
}
// 获取品类筛选条件
export function getCategoryList() {
  return request({
    url: '/exhibition/term/goods/category',
    method: 'get',
    params: {},
  })
}
// 获取爪型筛选条件
export function getClawList() {
  return request({
    url: '/exhibition/term/goods/claw',
    method: 'get',
    params: {},
  })
}
// 获取臂型筛选条件
export function getArmTypeList() {
  return request({
    url: '/exhibition/term/goods/arm',
    method: 'get',
    params: {},
  })
}
// 获取系列名称
export function getSeriesName() {
  return request({
    url: '/exhibition/term/goods/series',
    method: 'get',
    params: {},
  })
}

// ------------------------------------
export function getColumnList() {
  return request({
    url: '/exhibition/column',
    method: 'get',
  })
}

export function getFilterOptions(data) {
  return request({
    url: '/exhibition/product/queryGeneraName',
    method: 'POST',
    data,
  })
}
